module.exports = __webpack_public_path__ + "0378eb495663193202c288408dee8689.png";